import { PostTypes } from 'constants/postTypes'
import React, { useMemo } from 'react'

import { DeletePostModal } from 'partials/DeletePostModal'
import { NavMenuButton } from 'partials/MobileNav/types'
import { Page } from 'partials/Page'
import { WorkoutEditorForm } from 'partials/WorkoutEditorForm'

import { ScrollView } from 'widgets/ScrollView'
import { Toast as ToastComponent } from 'widgets/Toast'

import { useProgram } from 'hooks/useProgram'
import { useWorkoutEditor } from 'hooks/useWorkoutEditor'

import { links } from 'utils/constants'

import { useFocusMode } from 'contexts/FocusModeContext'

import { ProgramType } from 'types/program'

import { DiscardChangesModal } from './subcomponents/DiscardChangesModal'

export const WorkoutEditorPage = ({ navigation, route }: any) => {
  const focusMode = useFocusMode()
  const isFocusMode = useMemo(() => focusMode.group !== undefined, [focusMode.group])

  const postId = route?.params?.postId
  const isEditing = route?.name === links.EDIT_WORKOUT_PAGE

  const onAdd = route?.params?.onAdd
  const programId = route?.params?.programId

  const { data: program, updateProgram } = useProgram(focusMode.group?.id)

  const updateActions = (actionIds: string[]) => {
    if (!program || focusMode.group?.type !== ProgramType.PROGRAM) return
    updateProgram.mutate({ ...program, actions: actionIds })
  }

  const handleOnPublishSuccess = (id?: string) => {
    if (!id) return
    onAdd ? onAdd([id]) : updateActions([id])
  }

  const {
    postFormData,
    saveMultipleSteps,
    createPostLoading,
    editPostLoading,
    addStep,
    handlePublish,
    saveDetails,
    deleteStepAtIndex,
    openModalName,
    closeDeleteModal,
    closeDiscardModal,
    discardChanges,
  } = useWorkoutEditor({
    postType: PostTypes.WORKOUT,
    isEditing,
    postId,
    programId: programId ?? focusMode.group?.id,
    onPublish: handleOnPublishSuccess,
  })

  const doneButton: NavMenuButton = {
    title: 'Done',
    titleColor: !isFocusMode ? 'greyDarkest' : 'white',
    onPress: handlePublish,
  }

  return (
    <>
      <Page
        withNav
        withBack
        enableKeyboardAvoidingView
        title='Workout Builder'
        backgroundColor='white'
        isLoading={createPostLoading || editPostLoading}
        navigation={navigation}
        navbarRightButtons={[doneButton]}
      >
        <ScrollView>
          <WorkoutEditorForm
            addStep={addStep}
            initialData={postFormData}
            saveDetails={saveDetails}
            saveMultipleSteps={saveMultipleSteps}
            deleteStepAtIndex={deleteStepAtIndex}
          />
          <ToastComponent />
        </ScrollView>
      </Page>

      {postId && (
        <DeletePostModal
          handleClose={closeDeleteModal}
          isOpen={openModalName === 'delete'}
          postId={postId}
        />
      )}
      <DiscardChangesModal
        handleClose={closeDiscardModal}
        handleDiscard={discardChanges}
        isVisible={openModalName === 'discardChanges'}
      />
    </>
  )
}
